/* Joeba hero blog-rail: arrow scrolling + theme/city filter on mini-cards.
   Chip-render gebeurt in main-blog.liquid (één bron van waarheid). */
(function(){
  function rails(){ return Array.prototype.slice.call(document.querySelectorAll('[data-jb-hero-rail]')); }
  function visibleCards(r){ return Array.prototype.slice.call(r.querySelectorAll('.jb-mini-card')).filter(function(c){ return c.offsetParent !== null && !c.classList.contains('jb-mini-hidden'); }); }

  function updateArrows(r){
    if (!r) return;
    var w = r.closest('.joeba-country-hero__bloglist') || document.getElementById('joebaHeroBlogList');
    if (!r || !w) return;
    var max = Math.max(0, r.scrollWidth - r.clientWidth);
    var prev = w.querySelector('[data-jb-hero-rail-dir="prev"]');
    var next = w.querySelector('[data-jb-hero-rail-dir="next"]');
    var canScroll = max > 4 && visibleCards(r).length > 1;
    if (prev) prev.disabled = !canScroll || r.scrollLeft <= 2;
    if (next) next.disabled = !canScroll || r.scrollLeft >= max - 2;
  }

  function bindArrows(r){
    var w = r && (r.closest('.joeba-country-hero__bloglist') || document.getElementById('joebaHeroBlogList'));
    if (!w || !r) return;
    w.querySelectorAll('.jb-hero-rail-arrow').forEach(function(b){
      if (b.__jbHeroRailBound) return;
      b.__jbHeroRailBound = true;
      b.addEventListener('click', function(){
        var dir = b.getAttribute('data-jb-hero-rail-dir');
        var step = Math.max(220, r.clientWidth * 0.85);
        r.scrollBy({left:(dir==='next'?1:-1)*step, behavior:'smooth'});
        setTimeout(function(){ updateArrows(r); }, 280);
      });
    });
    if (!r.__jbHeroRailScrollBound) {
      r.__jbHeroRailScrollBound = true;
      r.addEventListener('scroll', function(){ updateArrows(r); }, {passive:true});
    }
    updateArrows(r);
  }

  // Filter mini-cards op thema + optionele stad-scope. theme==='all' = geen themafilter.
  window.jbHeroFilterRail = function(theme, cityHandle){
    var r = rail();
    if (!r) return;
    var scope = cityHandle || null;
    r.querySelectorAll('.jb-mini-card').forEach(function(c){
      var inScope = !scope || c.getAttribute('data-city-handle') === scope;
      var inTheme = !theme || theme === 'all' ||
        (c.getAttribute('data-jb-themes')||'').indexOf('|'+theme+'|') !== -1;
      c.classList.toggle('jb-mini-hidden', !(inScope && inTheme));
    });
    r.scrollTo({left:0, behavior:'smooth'});
    setTimeout(function(){ updateArrows(r); }, 50);
  };

  window.jbHeroRailRefresh = function(){
    rails().forEach(function(r){ bindArrows(r); updateArrows(r); });
  };

  function start(){
    window.jbHeroRailRefresh();
    window.addEventListener('resize', window.jbHeroRailRefresh);
    setTimeout(window.jbHeroRailRefresh, 200);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else { start(); }
})();
